// 配置编译环境和线上环境之间的切换
var baseUrl = '';
var iconfontVersion = ['567566_pwc3oottzol', '1066523_6bvkeuqao36'];
var iconfontUrl = "//at.alicdn.com/t/font_$key.css";
var codeUrl = "".concat(baseUrl, "/code");
var env = process.env;

if (env.NODE_ENV === 'development') {
  baseUrl = ""; // 开发环境地址
} else if (env.NODE_ENV === 'production') {
  baseUrl = ""; //生产环境地址
} else if (env.NODE_ENV === 'test') {
  baseUrl = ""; //测试环境地址
}

export { baseUrl, iconfontUrl, iconfontVersion, codeUrl, env };